export enum UserRolesEnum {
  ADMIN = 'ROLE_ADMIN',
  PRACTITIONER = 'ROLE_PRACTITIONER',
  SUBCONTRACTOR = 'ROLE_SUBCONTRACTOR',
}
